import { getAiAgentBlockTemplate } from '@nx-frontend/shared/blocks/flexible/templates/template-ai-agents';
import { FlexibleBlockProps, FlexibleBlockTemplate } from '@nx-frontend/shared/types';
import { getBannerBlockTemplate } from './templates/template-banner';
import { getCarouselBlockTemplate } from './templates/template-carousel';
import { getCodeBlockTemplate } from './templates/template-code';
import { getCountdownBlockTemplate } from './templates/template-countdown';
import { getCustomBlockTemplate } from './templates/template-custom';
import { getDiagramBlockTemplate } from './templates/template-diagram';
import { getFormBlockTemplate } from './templates/template-form';
import { getHeroCounsaltingBlockTemplate } from './templates/template-hero-counsalting';
import { getHeroEventBlockTemplate } from './templates/template-hero-event';
import { getHeroHeadlineBlockTemplate } from './templates/template-hero-headline';
import { getHeroImpressionBlockTemplate } from './templates/template-hero-impression';
import { getHeroSearchBlockTemplate } from './templates/template-hero-search';
import { getImageBlockTemplate } from './templates/template-image';
import { getInfoCardBlockTemplate } from './templates/template-info-card';
import { getIntegrationBlockTemplate } from './templates/template-integration';
import { getLimitBlockTemplate } from './templates/template-limit';
import { getProcessActionBlockTemplate } from './templates/template-process-action';
import { getProcessStateBlockTemplate } from './templates/template-process-state';
import { getSubmenuBlockTemplate } from './templates/template-submenu';
import { getTextBlockTemplate } from './templates/template-text';
import { getTilesBlockTemplate } from './templates/template-tiles';
import { getTimelineBlockTemplate } from './templates/template-timeline';
import { getTitleBlockTemplate } from './templates/template-title';

export const getFlexibleBlockTemplate = ({ type, view }: FlexibleBlockTemplate): FlexibleBlockProps => {
  const templates: FlexibleBlockProps[] =
    type === 'timeline'
      ? getTimelineBlockTemplate()
      : type === 'carousel'
      ? getCarouselBlockTemplate()
      : type === 'image'
      ? getImageBlockTemplate()
      : type === 'countdown'
      ? getCountdownBlockTemplate()
      : type === 'submenu'
      ? getSubmenuBlockTemplate()
      : type === 'code'
      ? getCodeBlockTemplate()
      : type === 'tiles'
      ? getTilesBlockTemplate()
      : type === 'hero-event'
      ? getHeroEventBlockTemplate()
      : type === 'hero-impression'
      ? getHeroImpressionBlockTemplate()
      : type === 'info-card'
      ? getInfoCardBlockTemplate()
      : type === 'hero-search'
      ? getHeroSearchBlockTemplate()
      : type === 'hero-headline'
      ? getHeroHeadlineBlockTemplate()
      : type === 'hero-counsalting'
      ? getHeroCounsaltingBlockTemplate()
      : type === 'process-state'
      ? getProcessStateBlockTemplate()
      : type === 'process-action'
      ? getProcessActionBlockTemplate()
      : type === 'limit'
      ? getLimitBlockTemplate()
      : type === 'form'
      ? getFormBlockTemplate()
      : type === 'banner'
      ? getBannerBlockTemplate()
      : type === 'title'
      ? getTitleBlockTemplate()
      : type === 'text'
      ? getTextBlockTemplate()
      : type === 'integration'
      ? getIntegrationBlockTemplate()
      : type === 'diagram'
      ? getDiagramBlockTemplate()
      : type === 'ai-agent'
      ? getAiAgentBlockTemplate()
      : getCustomBlockTemplate();

  return templates.find(({ template }) => template.view === view) ?? templates[0];
};
